import { toast } from "sonner";
import { create } from "zustand";

import type { NewTransactionOptions } from "@/types/paystack";

import PaystackPop from "@paystack/inline-js";

export interface Transaction {
	reference: string;
	status: string;
	amount: number;
}
interface PaystackStore {
	paystackInstance: PaystackPop | null;
	currentTransaction: Transaction | null;
	isPending: boolean;
	initializePayment: (options: NewTransactionOptions) => Promise<void>;
	setCurrentTransaction: (transaction: Transaction | null) => void;
}

export const usePaystackStore = create<PaystackStore>((set, get) => ({
	paystackInstance: null,
	currentTransaction: null,
	isPending: false,

	initializePayment: async (options: NewTransactionOptions) => {
		try {
			set({ isPending: true });
			let instance = get().paystackInstance;

			if (!instance) {
				instance = new PaystackPop();
				set({ paystackInstance: instance });
			}

			const enhancedOptions: NewTransactionOptions = {
				...options
			};

			instance.newTransaction(enhancedOptions);
			set({ isPending: false });
		}
		catch (error) {
			console.error(error);
			toast.error("An error occurred while initializing the payment.");
			set({ isPending: false });
		}
	},

	setCurrentTransaction: transaction => set({ currentTransaction: transaction })
}));
